import { ofType } from "redux-observable";
import { of } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionLeagueRankingReceived, TypeActionTournament, } from "../actionTournament";
export var epicTournamentGetPlayerRankings = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionTournament.GetPlayerLeagueRanking), switchMap(function (action) {
        return deps
            .netSend({
            id: CommandCode.PlayerLeagueRanking,
            props: {
                eventId: action.eventId,
                playerId: action.playerId,
            },
        })
            .pipe(retry(), switchMap(function (res) {
            return of(actionLeagueRankingReceived(res, EventType.PlayerLeague));
        }));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/epics/epicTournamentGetPlayerRankings.ts
// module id = 2443
// module chunks = 3